var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityCheckc7Af26D2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7165 6.47344L22.1071 6.18639C23.1117 5.97926 24.1117 6.56069 24.4197 7.53242L24.8465 8.87711L26.1961 9.31868C27.1706 9.63771 27.743 10.6374 27.5209 11.6311L27.2135 13.0071L28.1591 14.0581C28.8423 14.8174 28.8349 15.9669 28.1423 16.7182L27.1826 17.7578L27.4719 19.1378C27.6806 20.1349 27.0947 21.1272 26.1156 21.4329L24.7606 21.8565L24.3157 23.1959C23.9942 24.163 22.9869 24.7311 21.9856 24.5106L20.5991 24.2056L19.5388 25.1433C18.7737 25.8213 17.6154 25.814 16.8584 25.1267L15.8108 24.1743L14.4202 24.4613C13.4156 24.6685 12.4157 24.087 12.1076 23.1153L11.6808 21.7706L10.3312 21.329C9.35676 21.01 8.78431 20.0103 9.00644 19.0166L9.31381 17.6406L8.36889 16.589C7.68571 15.8297 7.69309 14.6802 8.38567 13.9289L9.34535 12.8892L9.0561 11.5092C8.84739 10.5122 9.43326 9.51982 10.4124 9.21412L11.7674 8.79053L12.2123 7.45116C12.5338 6.4841 13.5411 5.91598 14.5424 6.13644L15.9289 6.44148L16.9886 5.50372C17.7536 4.82571 18.9119 4.83303 19.669 5.52037L20.7165 6.47344Z",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 15.7073L16.6629 18.766L22.2642 13.4131",
    stroke: "#4DBB3E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7848 21.0596L30.2615 25.4945L25.9061 26.8497L24.7027 31.0007L19.0586 25.4101",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6912 21.0596L6.25977 25.4448L10.6594 26.8122L11.8751 31.0007L17.4626 25.4723",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityCheckc7Af26D2);
export default __webpack_public_path__ + "static/media/quality-check.c7af26d2.0059d79c92cbc78b0329d5170d1fd719.svg";
export { ForwardRef as ReactComponent };